import React, { useEffect, useState } from 'react'
import { getAudioManager, type AudioPreferencesV1 } from '../game/audio'

/** Compact topbar audio controls — mute + optional volume popover. Not on MatchBar. */
export const AudioControls: React.FC = () => {
  const audio = getAudioManager()
  const [prefs, setPrefs] = useState<AudioPreferencesV1>(() => audio.preferences)
  const [open, setOpen] = useState(false)

  useEffect(() => audio.subscribe(() => setPrefs(audio.preferences)), [audio])

  return (
    <div className="audio-controls">
      <button
        type="button"
        className="topbar-slot audio-controls__mute"
        aria-pressed={prefs.muted}
        aria-label={prefs.muted ? 'Unmute sound' : 'Mute sound'}
        title={prefs.muted ? 'Unmute' : 'Mute'}
        data-testid="audio-mute"
        onPointerUp={(e) => {
          e.preventDefault()
          audio.unlock()
          audio.setMuted(!prefs.muted)
          if (prefs.muted) audio.play('ui.confirm')
        }}
      >
        {prefs.muted ? 'Muted' : 'Sound'}
      </button>
      <button
        type="button"
        className="topbar-slot audio-controls__gear"
        aria-expanded={open}
        aria-label="Sound settings"
        data-testid="audio-settings"
        onPointerUp={(e) => {
          e.preventDefault()
          audio.unlock()
          setOpen((v) => !v)
        }}
      >
        ▽
      </button>
      {open ? (
        <div className="audio-controls__popover" role="dialog" aria-label="Sound settings">
          <label className="audio-controls__row">
            <span>Master</span>
            <input
              type="range"
              min={0}
              max={1}
              step={0.05}
              value={prefs.masterVolume}
              data-testid="audio-master"
              onChange={(e) => {
                audio.unlock()
                audio.setMasterVolume(Number(e.target.value))
              }}
            />
          </label>
          <label className="audio-controls__row">
            <span>SFX</span>
            <input
              type="range"
              min={0}
              max={1}
              step={0.05}
              value={prefs.sfxVolume}
              data-testid="audio-sfx"
              onChange={(e) => {
                audio.unlock()
                audio.setSfxVolume(Number(e.target.value))
              }}
            />
          </label>
        </div>
      ) : null}
    </div>
  )
}
